import { render, staticRenderFns } from "./gljg.vue?vue&type=template&id=79b52569&scoped=true"
import script from "./gljg.vue?vue&type=script&lang=js"
export * from "./gljg.vue?vue&type=script&lang=js"
import style0 from "./gljg.vue?vue&type=style&index=0&id=79b52569&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b52569",
  null
  
)

export default component.exports